module.exports = __webpack_public_path__ + "fonts/2F59F3_7_0.9db6c3f.woff";